import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import theme from "../../../theme";

export const PersonalizationOrderMetricIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "18px", height: props.height ?? "18px" }}
    >
      <svg
        {...props}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <mask
            id="mask0_1856_12547"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="18"
            height="18"
          >
            <rect width="18" height="18" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1856_12547)">
            <path
              d="M8.25 16.2938V9.43125L2.25 5.9625V11.9813C2.25 12.2563 2.31563 12.5063 2.44688 12.7313C2.57812 12.9563 2.7625 13.1375 3 13.275L8.25 16.2938ZM9.75 16.2938L15 13.275C15.2375 13.1375 15.4219 12.9563 15.5531 12.7313C15.6844 12.5063 15.75 12.2563 15.75 11.9813V5.9625L9.75 9.43125V16.2938ZM12.7313 5.98125L14.9438 4.6875L9.75 1.70625C9.5125 1.56875 9.2625 1.5 9 1.5C8.7375 1.5 8.4875 1.56875 8.25 1.70625L6.76875 2.55L12.7313 5.98125ZM9 8.1375L11.2313 6.8625L5.2875 3.4125L3.0375 4.70625L9 8.1375Z"
              fill="#6C6C6C"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
